import { render, staticRenderFns } from "./SignUpDone.vue?vue&type=template&id=f86ac80e&scoped=true&"
import script from "./SignUpDone.vue?vue&type=script&lang=js&"
export * from "./SignUpDone.vue?vue&type=script&lang=js&"
import style0 from "./SignUpDone.vue?vue&type=style&index=0&id=f86ac80e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86ac80e",
  null
  
)

export default component.exports